import React from 'react';
import './Footer.css';

function Footer({ onPrivacy, onTerms }) {
  const year = new Date().getFullYear();

  return (
    <footer className="app-footer" role="contentinfo">
      <span className="app-footer-copy">
        © {year} Saneamento Vivo
      </span>
      <div className="app-footer-divider" aria-hidden="true" />
      <button className="app-footer-link" onClick={onPrivacy}>
        Política de Privacidade
      </button>
      <div className="app-footer-divider" aria-hidden="true" />
      <button className="app-footer-link" onClick={onTerms}>
        Termos de Uso
      </button>
      <div className="app-footer-divider" aria-hidden="true" />
      <a
        href="https://www.gov.br/governodigital/pt-br/acessibilidade-e-usuario/acessibilidade-digital"
        className="app-footer-link"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Declaração de acessibilidade (abre em nova aba)"
      >
        Acessibilidade
      </a>
    </footer>
  );
}

export default Footer;
